import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Dialog, Skeleton } from 'react-vant';
import {
  apiGetH5CloseOrder,
  apiGetH5GetPayList,
  apiGetH5LoginUser,
  apiGetH5PayGoodsOrder,
  apiGetH5QueryOrder,
  apiGetWeChatSignature,
} from '../api';
import AppBar from '../components/appBar';
import CountdownTimer from '../components/countdown_timer';
import Empty from '../components/empty';
import LoginPage from '../components/loginPage';
import NotWxPageDialog from '../components/notWxPageDialog';
import Page from '../components/page';
import RefundDialog from '../components/refundDialog';
import main from '../main';
import { Order, PayConfig } from '../types';
import showPayPage, { PayType } from '../utils/pay';
import { cardOrderStatusData, operatorsTypeData } from '../utils/source';
import { copyToClipboard, dictLabel, isWeixinEnv, parseLocationParams, showConfirm, showToast } from '../utils/utils';

export default function OrderListPage() {
  let location = useLocation();
  let navigate = useNavigate();
  const [token, settoken] = useState(main?.token ?? '');
  const [orderList, setOrderList] = useState<Array<Order>>([]);
  const [errorTxt, setErrorTxt] = useState('未查询到您的订单');
  // 是否显示顶部返回按钮
  const [isMenuHide, setisMenuHide] = useState<boolean>(false);
  // 记录商品列表请求状态
  const [isSkeleton, setisSkeleton] = useState<boolean>(false);
  // 支付配置列表
  const [payConfigList, setPayConfigList] = useState<PayConfig[]>([]);
  // 微信支付配置准备完成
  const [wxReady, setWxReady] = useState(false);
  // 支付链接
  const [payUrl, setpayUrl] = useState<string>();
  // 支付弹窗提示
  const [payTips, setpayTips] = useState<string>();

  // 申请退款
  const [refundDialogShow, setRefundDialogShow] = useState<string>();
  const [history, sethistory] = useState<boolean>(false);

  useEffect(() => {
    if (location?.pathname) {
      // 详情页面点击的订单查询路由为orderList，tabbar路由为order
      sethistory(location?.pathname.includes('orderList'));
    }
    let _p = parseLocationParams(location.search) ?? {};
    if (_p.isHide) {
      setisMenuHide(_p.isHide === 'true');
    }
    if (_p.code) {
      main.setShopId(_p.code);
    }
  }, [location]);

  useEffect(() => {
    getH5LoginUser();
    getH5GetPayList();
    // getOpenId();
  }, []); // eslint-disable-line
  // 支付配置列表
  async function getH5GetPayList() {
    try {
      let res = await apiGetH5GetPayList();
      let data = res.data;
      if (data.code === 200) {
        setPayConfigList(data?.data ?? []);
      }
    } catch (error) {}
  }

  // 获取OPENID
  // async function getOpenId() {
  //   try {
  //     let res = await apiGetOpenId(main.code!, main.appId);
  //     let data = res.data;
  //     if (data.code === 200) {
  //       main.openId = data.data;
  //       localStorage.setItem(main.appId, main.openId ?? '');
  //     }
  //   } catch (e) {}
  // }

  function wxPayReady() {
    if (!isWeixinEnv()) return;
    // @ts-ignore
    if (typeof WeixinJSBridge === 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', () => setWxReady(true), false);
        // @ts-ignore
      } else if (document.attachEvent) {
        // @ts-ignore
        document.attachEvent('WeixinJSBridgeReady', () => setWxReady(true));
      }
    } else {
      setWxReady(true);
    }
  }

  // 检验token是否失效
  async function getH5LoginUser() {
    setisSkeleton(true);
    try {
      let res = await apiGetH5LoginUser();
      let data = res.data;
      if (data.code === 200) {
        handleSearchOrder();
        wxPayReady();
      } else {
        setisSkeleton(false);
        handleLoginOut();
        // showToast(data?.msg ?? '登录已失效');
      }
    } catch (e: any) {
      setisSkeleton(false);
      setErrorTxt(e.message ?? '暂无记录');
    }
  }
  // 查询列表页
  async function handleSearchOrder() {
    try {
      let res = await apiGetH5QueryOrder();
      let data = res.data;
      if (data.code === 200) {
        setOrderList(data.data);
      } else {
        setOrderList([]);
        setErrorTxt(data.msg ?? '暂无记录');
      }
    } catch (e: any) {
      setErrorTxt(e.message ?? '暂无记录');
    } finally {
      setisSkeleton(false);
    }
  }
  function toView(url: string, state?: any) {
    navigate(url, { state });
  }
  // 关闭订单
  async function handleCloseOrder(item: Order) {
    Dialog.confirm({
      title: '关闭订单',
      message: '确定要关闭订单吗',
      confirmButtonColor: '#f86404',
    })
      .then(() => {
        closeOrder(item);
      })
      .catch(() => {});
  }
  useEffect(() => {
    if (isWeixinEnv()) {
      wxConfig();
    }
  }, []);
  async function wxConfig() {
    // @ts-ignore
    let wx = window.wx;
    // 不写ready方法了，因为使用wx-open-launch-weapp的时候是在最终用户点了去支付按钮后 必定ready了
    let res = await apiGetWeChatSignature(
      main.isIos14 ? main.enterUrl : window.location.href.split('#')[0],
      main.appId
    );
    let data = res.data;
    if (data.code === 200) {
      let _data = data.data;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: main.appId, // 必填，公众号的唯一标识
        timestamp: _data.timestamp, // 必填，生成签名的时间戳
        nonceStr: _data.nonceStr, // 必填，生成签名的随机串
        signature: _data.signature, // 必填，签名
        jsApiList: [], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-weapp', 'checkJsApi'],
      });
    }
  }
  async function closeOrder(item: Order) {
    try {
      let res = await apiGetH5CloseOrder({ id: item?.id });
      let data = res.data;
      if (data.code === 200) {
        handleSearchOrder();
      } else {
        showToast(data.msg ?? '暂无记录');
      }
    } catch (error) {}
  }
  function verifyPayMent() {
    let arr = [];
    let tips = '';
    if (payConfigList.length === 0) {
      showToast('获取支付信息失败，请稍后再试');
      return false;
    }
    if (isWeixinEnv()) {
      if (!wxReady || !main.openId) {
        showToast('微信支付初始化失败，请刷新重试');
        return false;
      }
      arr = payConfigList.filter((i: { payType: string }) => i.payType.indexOf('wechatJsPay') !== -1);
      if (arr.length === 0) {
        tips = '请在支付宝内打开该链接';
      }
    } else {
      arr = payConfigList.filter((i: { payType: string }) => i.payType.indexOf('alipay') !== -1);
      if (arr.length === 0) {
        tips = '请在微信内打开该链接';
      }
    }
    if (!!tips) {
      setpayUrl(window.location.href);
      setpayTips(tips);
      return false;
    }
    return true;
  }
  // 立即支付
  async function handlePayGoodsOrder(item: Order) {
    if (!verifyPayMent()) return;
    try {
      let res = await apiGetH5PayGoodsOrder({
        id: item?.id,
        openId: main.openId,
        appId: main.appId,
        // payType: isWeixinEnv() ? PayType.WECHATJSPAY : PayType.ALIPAY,
        payType: isWeixinEnv() ? PayType.JSDH5WX : PayType.ALIPAY,
      });
      let data = res.data;

      if (data.code === 200) {
        let _data = data.data;
        let payRes = await showPayPage(_data, 'alipay');

        if (payRes.code === 200) {
          showToast('支付成功');
          handleSearchOrder();
        } else if (payRes.code === 300) {
          window.location.href = payRes.url;
        } else if (payRes.code === 400) {
          await showConfirm({
            title: '提示',
            content: '是否支付完成?',
            confirmBtnText: '支付完成',
            cancelBtnText: '未完成',
            onConfirm: () => {},
            onCancel: () => {},
          });
          handleSearchOrder();
        } else {
          showToast(payRes.msg);
        }
      }
    } catch (error) {}
  }
  // 退出登录
  async function handleLoginOut() {
    main.token = '';
    settoken('');
    localStorage.removeItem('token');
  }
  // 登录页面
  if (!token) {
    return (
      <LoginPage
        onLogin={(v) => {
          settoken(v);
          getH5LoginUser();
        }}
      />
    );
  }
  // 请求列表时显示骨架屏
  if (isSkeleton) {
    return (
      <div className="bw-100 hvh-100 pt-10">
        <Skeleton rowHeight={15} row={15} />
      </div>
    );
  }

  return (
    <Page
      navPage={!history}
      className="order-list-page d-flex-c"
      contentClassName="flex-1 h-1 d-flex-c"
      appBar={
        isMenuHide || !history ? (
          <AppBar
            showBack={false}
            className="bg-p text-color-white"
            title="我的订单"
            // action={
            //   <div className="d-flex-r ai-center" onClick={handleLoginOut}>
            //     登出
            //     <img className="w-15 ml-5" src="/pic/icon_loginout.png" alt="" />
            //   </div>
            // }
            actionClassName="d-flex-r ai-center"
          />
        ) : (
          <AppBar showBack onBack={() => navigate(-1)} className="bg-transparent" title="订单查询" />
        )
      }
    >
      <div className="flex-1 h-1 overflow-y">
        {!orderList.length && !isSkeleton && (
          <div className="d-flex-c ai-center">
            <Empty
              tips={errorTxt}
              tipsClassName="font-size-16 font-widget-500"
              showBackBtn={false}
              pic="/pic/no_data.png"
            />
            <div className="mt-20 change-btn pl-10 pr-10 pt-5 pb-5 bg-white text-color-p" onClick={handleLoginOut}>
              重新查询
            </div>
          </div>
        )}
        {orderList.map((i, idx) => (
          <div key={idx} className="mb-10 bg-white pt-15 pb-15 box-shadow">
            <div className="d-flex-r ai-center jc-between font-size-12 border-bottom pl-15 pr-15  pb-5 mb-5">
              <div className="d-flex-r ai-center" onClick={() => copyToClipboard(i?.orderSn!)}>
                <span className="text-color-9">订单编号：</span>
                {i?.orderSn}
                <img className="w-18" src="/pic/icon_order_copy.png" alt="" />
              </div>
              <div className="text-color-9 font-size-10">{i?.createTime ?? ''}</div>
            </div>
            <div className="pl-15 pr-15 d-flex-r ai-center jc-between font-size-16 font-widget-600">
              <div>{dictLabel(i?.operatorsType, operatorsTypeData)}通信专营授权店</div>
              <div className="text-color-p">
                {i?.remark?.includes('客户端订单关闭')
                  ? '已关闭'
                  : i?.orderPayStatus === 'wait'
                  ? '待支付'
                  : i?.orderPayStatus === 'z-close'
                  ? '已关闭'
                  : dictLabel(i?.orderStatus, cardOrderStatusData)}
              </div>
            </div>

            <div className="pl-15 pr-15 d-flex-r mt-10 font-size-14 pb-10">
              <img className="w-90 h-90 bg-p border-radius-4" src={i?.goodsHeadImg} alt="" />
              <div className="flex-1 ml-20 d-flex-c">
                <div className="flex-1">
                  <div className="omit-text-2">{i?.orderName}</div>
                </div>

                <div className="d-flex-r jc-end ai-end">
                  <span className="text-color-6">实付金额:</span>
                  <div className="ml-5 font-size-16">
                    ¥{Number(i?.payAmount ?? 0).toFixed(2)}
                    <span className="ml-2">
                      {Number(i?.carryPrice) > 0 ? <span>（运费:{i?.carryPrice}）</span> : '(免运费)'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {['error', 'intercept', 'abnormal'].includes(i?.orderStatus!) && (
              <div className="pl-15 pr-15 mt-10">
                <span className="text-color-6">订单说明：</span>
                {i?.orderStatusDesc}
              </div>
            )}
            <div className="pl-15 pr-15 d-flex-r ai-center jc-between mt-10">
              <div>
                {i?.orderPayStatus === 'wait' && i?.remainingPayTime && Number(i?.remainingPayTime ?? 0) > 0 ? (
                  <CountdownTimer
                    isshowWarning={false}
                    props=""
                    className="text-color-p"
                    totalMilliseconds={i?.remainingPayTime}
                    onExpire={() => handleSearchOrder()}
                  />
                ) : null}
              </div>
              <div className="d-flex-r">
                {(i?.orderPayStatus === 'wait' ||
                  i?.orderStatus === 'error' ||
                  i?.orderStatus === 'no_shipped' ||
                  i?.orderStatus === 'abnormal') &&
                  !i?.remark?.includes('客户端订单关闭') && (
                    <div
                      className="ml-10 w-80 h-35 d-flex-r ai-center jc-center bg-gray border-radius-8"
                      onClick={() => handleCloseOrder(i)}
                    >
                      关闭订单
                    </div>
                  )}
                {i?.orderPayStatus === 'wait' && (
                  <>
                    <div
                      className="ml-10 w-80 h-35 d-flex-r ai-center jc-center bg-gray border-radius-8"
                      onClick={() => toView(`/changeAddress?id=${i?.id}`)}
                    >
                      修改地址
                    </div>
                    <div
                      className="ml-10 w-80 h-35 d-flex-r ai-center jc-center bg-p text-color-white border-radius-8"
                      onClick={() => handlePayGoodsOrder(i)}
                    >
                      立即支付
                    </div>
                  </>
                )}
                {(i?.orderPayStatus === 'z-close' || i?.remark?.includes('客户端订单关闭')) &&
                  Number(i?.linkTimeout ?? 0) === 0 && (
                    <div
                      className="pay-btn ml-10 w-80 h-35 d-flex-r ai-center jc-center bg-p text-color-white border-radius-8"
                      onClick={() => toView(`/product?id=${i?.goodsCode}`)}
                    >
                      再来一单
                    </div>
                  )}

                {['error', 'abnormal', 'intercept'].includes(i?.orderStatus ?? '') && i?.ifPhoto === 'Y' && (
                  <div
                    className="pay-btn ml-10 w-80 h-35 d-flex-r ai-center jc-center bg-p text-color-white border-radius-8"
                    onClick={() => toView(`/supCertificates?id=${i?.id}`)}
                  >
                    补传三证
                  </div>
                )}
                {['shipped', 'activate', 'first_flush'].includes(i?.orderStatus ?? '') && (
                  <div
                    className="ml-10 w-80 h-35 d-flex-r ai-center jc-center bg-gray border-radius-8"
                    onClick={() => toView(`/logistics?id=${i?.id}`)}
                  >
                    查看物流
                  </div>
                )}
                {i?.orderPayStatus !== 'wait' && i?.orderPayStatus !== 'z-close' && (
                  <div
                    className="service-btn ml-10 w-78 h-35 d-flex-r ai-center jc-center border-radius-8"
                    onClick={() => toView(`/applySales?id=${i?.id}`)}
                  >
                    申请售后
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* 申请退款弹窗 */}
      {!!refundDialogShow && (
        <RefundDialog
          orderSn={refundDialogShow}
          onClose={(v) => {
            setRefundDialogShow(undefined);
            if (v) handleSearchOrder();
          }}
        />
      )}
      {!!payUrl && (
        <NotWxPageDialog
          iconShow={false}
          cancelShow={true}
          title="复制链接"
          url={payUrl}
          content={payUrl}
          contentTips={payTips}
          confirmText="复制链接"
          onClose={() => setpayUrl(undefined)}
        />
      )}
    </Page>
  );
}
